<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="160px">
            <el-form-item label="订单编号：" prop="sn">
                <span>{{model.sn}}</span>
            </el-form-item>
            <el-form-item label="会员ID：" prop="member_id">
                <span>{{model.member_id}}</span>
            </el-form-item>
            <el-form-item label="订单状态：" prop="status">
                <span>{{ transEnu(model.status, "order_status") }}</span>
            </el-form-item>
            <el-form-item label="创建时间：" prop="createtime">
                <span>{{model.createtime}}</span>
            </el-form-item>
            <el-form-item label="支付时间：" prop="paytime">
                <span>{{model.paytime}}</span>
            </el-form-item>
            <el-form-item label="审核时间：" prop="confirmtime">
                <span>{{model.confirmtime}}</span>
            </el-form-item>
            <el-form-item label="发货时间：" prop="sendtime">
                <span>{{model.sendtime}}</span>
            </el-form-item>
            <el-form-item label="完成时间：" prop="completetime">
                <span>{{model.completetime}}</span>
            </el-form-item>
            <el-form-item label="所在区域：" prop="regions">
                <span>{{model.regions}}</span>
            </el-form-item>
            <el-form-item label="收货地址：" prop="address">
                <span>{{model.address}}</span>
            </el-form-item>
            <el-form-item label="收货人：" prop="receiver">
                <span>{{model.receiver}}</span>
            </el-form-item>
            <el-form-item label="收货人电话：" prop="receiver_phone">
                <span>{{model.receiver_phone}}</span>
            </el-form-item>
            <el-form-item label="商品数量：" prop="goods_count">
                <span>{{model.goods_count}}</span>
            </el-form-item>
            <el-form-item label="订单总额：" prop="order_price">
                <span>{{model.order_price}}</span>
            </el-form-item>
            <el-form-item label="商品金额：" prop="goods_price">
                <span>{{model.goods_price}}</span>
            </el-form-item>
            <el-form-item label="配送费：" prop="post_fee">
                <span>{{model.post_fee}}</span>
            </el-form-item>
            <el-form-item label="支付方式：" prop="pay_type">
                <span>{{ transEnu(model.pay_type, "pay_type") }}</span>
            </el-form-item>
            <el-form-item label="支付金额：" prop="pay_price">
                <span>{{model.pay_price}}</span>
            </el-form-item>
            <el-form-item label="在线支付：" prop="pay_online">
                <span>{{model.pay_online}}</span>
            </el-form-item>
            <el-form-item label="在线支付(减去退款后)：" prop="pay_online">
                <span>{{model.pay_online_remaining}}</span>
            </el-form-item>
            <el-form-item label="退款金额：" prop="pay_online">
                <span>{{model.refound_money}}</span>
            </el-form-item>
            <el-form-item label="积分金额：" prop="pay_balance">
                <span>{{model.pay_balance}}</span>
            </el-form-item>
            <el-form-item label="买家备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="买家留言：" prop="remark_shop">
                <el-input type="textarea" v-model="model.remark_shop" rows="3"></el-input>
            </el-form-item>
            <el-form-item label="后台备注：" prop="remark_admin">
                <el-input type="textarea" v-model="model.remark_admin" rows="3"></el-input>
            </el-form-item>
            <el-form-item label="快递公司：" prop="express">
                <el-input v-model="model.express"></el-input>
            </el-form-item>
            <el-form-item label="快递单号：" prop="express_num">
                <el-input v-model="model.express_num"></el-input>
            </el-form-item>
        </el-form>
        <div class="dataBox" style="margin-top: 20px">
            <el-table :data="orderItems" border stripe>
                <el-table-column prop="goods_name" label="商品名称" sortable="custom"></el-table-column>
                <el-table-column prop="brand" label="品牌" sortable="custom"></el-table-column>
                <el-table-column prop="spec" label="规格名称" sortable="custom" width="160"></el-table-column>
                <el-table-column prop="sku" label="规格编码" sortable="custom" width="160"></el-table-column>
                <el-table-column prop="price" label="价格" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="num" label="数量" sortable="custom" width="100"></el-table-column>
            </el-table>
        </div>
        <div class="dataBox" style="margin-top: 40px">
            <el-table :data="orderLogs" border stripe>
                <el-table-column prop="status_txt" label="日志类型" width="120"></el-table-column>
                <el-table-column prop="addtime" label="时间" width="160"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="user_name" label="操作人" sortable="custom" width="120"></el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="danger" v-if="model.status && (model.status==1 || model.status==2 || model.status==3 || model.status==6)" @click="refundOrderPart" size="medium">部分退款</el-button>
            <el-button type="danger" v-if="model.status && (model.status==1 || model.status==2 || model.status==3 || model.status==6)" @click="refundOrder" size="medium">退 款</el-button>
            <el-button type="primary" v-if="model.status && model.status == 1" @click="confirmOrder" size="medium">确 认</el-button>
            <el-button type="primary" v-if="model.status && model.status == 2" @click="sendOrder" size="medium">发 货</el-button>
            <el-button type="primary" @click="saveRemark" size="medium">保 存</el-button>
            <el-button @click="closeDialog" size="medium">关 闭</el-button>
        </div>
        <PartRefound
            width="600px"
            title="订单部分退款"
            :isshow="partreound_show"
            @on-close="closePrDialog"
            @on-save-ok="qrPr">
        </PartRefound>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById } from '@/api/common'
import { saveRemark, confirmOrder, sendOrder, refundOrder, refundOrderPart, refundOrderNew, refundOrderPartNew } from '@/api/orderdao'
import PartRefound from "./partrefound"

export default {
    name: 'orderInfo',
    mixins: [editutil],
    components: {PartRefound},
    data() {
        return {
            model: {
                sn: '',
                member_id: '',
                status: '',
                createtime: '',
                paytime: '',
                confirmtime: '',
                sendtime: '',
                completetime: '',
                regions: '',
                address: '',
                receiver: '',
                receiver_phone: '',
                goods_name: '',
                main_pic: '',
                remark: '',
                goods_count: '',
                member_coupon_id: '',
                post_type: '',
                order_price: '',
                goods_price: '',
                post_fee: '',
                coupon_price: '',
                pay_type: '',
                pay_price: '',
                pay_balance: '',
                pay_online: '',
                transaction_id: '',
                remark_shop: '',
                remark_admin: '',
                express: '',
                express_num: '',
            },
            orderItems: [],
            orderLogs: [],
            getObj:{
                url:'/api/admin/order/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['order_status', 'pay_type'],
            partreound_show: false,
        };
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data.order;
                        this.orderItems = res.data.orderItems;
                        this.orderLogs= res.data.orderLogs;
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        saveRemark(){
            saveRemark(this.id, this.model.remark_shop, this.model.remark_admin, this.model.express, this.model.express_num).then(res=>{
                if(res.code ==1){
                    this.$msgs("保存成功")
                }else{
                    this.$msg(res.msg)
                }
                this.getModelData()
            })
        },
        confirmOrder(){
            confirmOrder(this.id).then(res=>{
                if(res.code ==1){
                    this.$msgs("订单确认成功")
                }else{
                    this.$msg(res.msg)
                }
                this.getModelData()
            })
        },
        sendOrder(){
            sendOrder(this.id).then(res=>{
                if(res.code ==1){
                    this.$msgs("订单发货成功")
                }else{
                    this.$msg(res.msg)
                }
                this.getModelData()
            })
        },
        refundOrder(){
            this.$confirm('确定要退款吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                refundOrderNew(this.id).then(res=>{
                    if(res.code ==1){
                        this.$msgs("订单退款成功")
                    }else{
                        this.$msg(res.msg)
                    }
                    this.getModelData()
                })
            }).catch(() => { })
        },
        refundOrderPart(){
            this.partreound_show = true
        },
        closePrDialog(){
            this.partreound_show = false
        },
        qrPr(e){
            refundOrderPartNew(this.id, e.money, e.remark).then(res=>{
                if(res.code ==1){
                    this.$msgs("订单部分退款成功")
                }else{
                    this.$msg(res.msg)
                }
                this.getModelData()
            })
            this.partreound_show = false
        },
    }
};
</script>